module.exports = __webpack_public_path__ + "static/media/img-marca-faico-edificio.e8ec046c.png";